import { render, staticRenderFns } from "./RejectList.vue?vue&type=template&id=45b35624&scoped=true"
import script from "./RejectList.vue?vue&type=script&lang=js"
export * from "./RejectList.vue?vue&type=script&lang=js"
import style0 from "./RejectList.vue?vue&type=style&index=0&id=45b35624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b35624",
  null
  
)

export default component.exports